import { render } from "./Tirador.vue?vue&type=template&id=b951f75a&scoped=true"
import script from "./Tirador.vue?vue&type=script&lang=js"
export * from "./Tirador.vue?vue&type=script&lang=js"

import "./Tirador.vue?vue&type=style&index=0&id=b951f75a&scoped=true&lang=css"

import exportComponent from "/tmp/build_f9a89c39/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b951f75a"]])

export default __exports__